var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1338.5,4794.5c-49.7-25.4-91-67.7-112.1-114.2c-16.9-37-20.1-71.9-20.1-292.9v-249.6l-187.2-4.2 c-170.3-4.2-194.6-7.4-259.1-31.7c-198.8-75.1-343.7-220-418.8-418.8c-24.3-64.5-27.5-88.8-31.7-258l-4.2-188.2H2560h2254.8 l-4.2,188.2c-4.2,169.2-7.4,193.5-31.7,258c-76.1,199.9-218.9,342.7-418.8,418.8c-64.5,24.3-88.8,27.5-258,31.7l-188.2,4.2v247.5 c0,200.9-3.2,255.9-16.9,287.7c-34.9,83.5-116.3,139.6-205.2,139.6c-93.1,0-160.8-40.2-204.1-121.6 c-22.2-39.1-23.3-60.3-26.4-298.2l-3.2-257H2560h-897.9l-3.2,257c-3.2,238-4.2,259.1-26.4,298.2c-28.6,52.9-61.3,84.6-111,105.8 C1470.7,4816.7,1379.7,4816.7,1338.5,4794.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.5,1806.9l3.2-976.1l27.5-70.9C418.4,558.9,559.1,418.3,760,340l70.9-27.5h1718.6H4268l74,23.3 c203.1,64.5,371.2,230.6,442.1,436.8l23.3,68.7l3.2,970.9l2.1,969.8H2560H306.3L309.5,1806.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4de2bcffc63470eed563a896057b833c.svg";
export { ForwardRef as ReactComponent };